import { FC, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { TextField, IconButton, TextFieldProps } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { LoginFormFieldValues } from '@vs-online-only-app/state';

interface Props extends Omit<TextFieldProps, 'onChange'> {
  onChange: (value: string) => void;
}

const LoginFormPasswordField: FC<Props> = ({
  error,
  onBlur,
  onChange,
  disabled,
  label = 'Password',
  inputRef,
}) => {
  const {
    formState: { errors },
  } = useFormContext<LoginFormFieldValues>();
  const [isPasswordVisible, setIsPasswordVisible] = useState<boolean>(false);

  const handleFieldLinkClick = () => setIsPasswordVisible(!isPasswordVisible);

  return (
    <TextField
      label={`${label}${
        errors?.password?.message ? ` - ${errors.password.message}` : ''
      }`}
      inputRef={inputRef}
      variant="outlined"
      fullWidth
      type={isPasswordVisible ? 'text' : 'password'}
      error={error}
      onBlur={onBlur}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      slotProps={{
        input: {
          endAdornment: (
            <IconButton onClick={handleFieldLinkClick}>
              {isPasswordVisible ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          ),
        },
      }}
    />
  );
};

export default LoginFormPasswordField;
